import { AdTabProps } from "./tab";

enum AdTabsEnum {
  RGCams="RGCams",
  LiveSex="LiveSex",
}

type AdTabsProps = {
  [name in AdTabsEnum]: AdTabProps;
}

export const tabs: AdTabsProps = {
  [AdTabsEnum.RGCams]: {
    link: "http://go.goaserv.com/redirect.go?pid=390&spaceid=1244529",
  },
  [AdTabsEnum.LiveSex]: {
    link: "http://bit.ly/42ukupf",
  },
};
